import { Injectable } from '@angular/core';
import { selectService } from '../../../../store/service/service.selectors';
import { ComponentStoreV2Factory } from '../../../../../shared/store/common/component-store-v2.factory';
import { toSignal } from '@angular/core/rxjs-interop';
import { globalStore } from '../../../../../shared/shared.global-service';

@Injectable()
export class ServiceSettingsVisitTypeStore extends ComponentStoreV2Factory {

    service = toSignal(globalStore!.select(selectService));

}
